module.exports = __webpack_public_path__ + "static/img/pt2.8cbcaa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sdwan/pt2.png
// module id = psz5
// module chunks = 0